import React, { useEffect, useState } from "react";
import { Menu, X, PawPrint, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { waLink } from "../lib/site";

const links = [
  { href: "#sobre", label: "Sobre" },
  { href: "#servicos", label: "Serviços" },
  { href: "#diferenciais", label: "Diferenciais" },
  { href: "#galeria", label: "Galeria" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#agendamento", label: "Agendamento" },
  { href: "#contato", label: "Contato" },
  { label: "Curso", href: "#pre-inscricao" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handle = () => setScrolled(window.scrollY > 20);
    handle();
    window.addEventListener("scroll", handle, { passive: true });
    return () => window.removeEventListener("scroll", handle);
  }, []);

  return (
    <header
      data-testid="navbar"
      className="fixed top-4 left-0 right-0 z-50 px-4 transition-all duration-500"
    >
      <div
        className={`container-pad h-20 flex items-center justify-between rounded-full border backdrop-blur-2xl transition-all duration-500 ${
          scrolled
            ? "bg-white/14 border-white/20 shadow-[0_25px_80px_rgba(0,0,0,0.22)]"
            : "bg-white/8 border-white/15 shadow-[0_20px_70px_rgba(0,0,0,0.14)]"
        }`}
      >
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
          <div className="w-11 h-11 rounded-2xl bg-gold flex items-center justify-center shadow-[0_15px_40px_rgba(242,169,0,.35)] group-hover:rotate-[-8deg] group-hover:scale-110 transition-all">
            <PawPrint className="w-6 h-6 text-royal" strokeWidth={2.2} />
          </div>

          <div className="leading-tight">
            <div className="font-heading text-lg font-semibold tracking-tight text-white">
              Tia Sandra
            </div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-gold font-medium">
              Pet Care
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="px-4 py-2 text-sm font-medium text-white/80 hover:text-white relative rounded-full hover:bg-white/10 after:absolute after:left-4 after:right-4 after:bottom-1 after:h-[2px] after:bg-gold after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            data-testid="nav-whatsapp-btn"
            asChild
            className="rounded-full bg-gold hover:bg-gold-hover text-royal font-bold px-6 py-5 shadow-[0_15px_40px_rgba(242,169,0,.35)] hover:shadow-[0_20px_55px_rgba(242,169,0,.5)] hover:-translate-y-0.5 transition-all"
          >
            <a href={waLink()} target="_blank" rel="noreferrer">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </a>
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 rounded-xl text-white hover:bg-white/10"
          onClick={() => setOpen((v) => !v)}
          aria-label="Abrir menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <div
        className={`lg:hidden mx-4 mt-3 overflow-hidden rounded-[28px] border border-white/15 bg-[#061738]/90 backdrop-blur-2xl transition-[max-height,opacity] duration-500 shadow-[0_25px_80px_rgba(0,0,0,0.30)] ${
          open ? "max-h-[650px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="p-4 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="px-4 py-3 rounded-2xl text-white/80 hover:bg-white/10 hover:text-white font-medium transition-all"
            >
              {l.label}
            </a>
          ))}

          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            className="mt-3 text-center rounded-full bg-gold hover:bg-gold-hover text-royal font-bold px-6 py-3 shadow-[0_15px_40px_rgba(242,169,0,.35)]"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}
